import { Blockquote as RadixBlockquote, Code as RadixCode, Em as RadixEm, Heading as RadixHeading, Kbd as RadixKbd, Link as RadixLink, Quote as RadixQuote, Strong as RadixStrong, Text as RadixText, } from '@radix-ui/themes';
import { withMappingProps } from '../../utils/radix.js';
export const Text = withMappingProps(RadixText);
export const Heading = withMappingProps(RadixHeading, {
    weight: 'medium',
});
export const Blockquote = withMappingProps(RadixBlockquote);
export const Code = withMappingProps(RadixCode);
export const Em = withMappingProps(RadixEm);
export const Kbd = withMappingProps(RadixKbd);
export const Link = withMappingProps(RadixLink);
export const Quote = withMappingProps(RadixQuote);
export const Strong = withMappingProps(RadixStrong);
//# sourceMappingURL=typography.js.map